import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectCorporateActionsCapsulesState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.CORPORATE_ACTIONS_CAPSULE];

export const selectCorporateActionsCapsuleState = (
    state: State,
    widgetKey: string
) => selectCorporateActionsCapsulesState(state)[widgetKey];
